import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import ModelTitle from 'components/ModelTitle';
import Icon from 'components/Icon';
import { getJobCategory, JobCategory } from '@/server/common';

const Index: React.FC = () => {
  const [category, setCategory] = useState<JobCategory>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getJobCategory()
      .then(res => {
        if (res && Array.isArray(res)) {
          setCategory(res);
        } else {
          console.error('获取职位分类失败，返回数据格式不正确');
        }
        setLoading(false);
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  const clickHandler = (id?: string): void => {
    location.href = `https://ooia5293gn.jobs.feishu.cn/index/position/list?functionCategory=${id}`;
  };

  const splitStringAtFirstSpace = (str: string): string => {
    if (!str || typeof str !== 'string') {
      return ''; // 容错处理，非字符串或空值返回空字符串
    }
    const index = str.indexOf(' ');
    return index !== -1
      ? str.slice(0, index) + '\n' + str.slice(index + 1)
      : str;
  };

  const isEmpty = useMemo((): boolean => {
    return category.every(category => category.jobCount === 0);
  }, [category]);

  return (
    <div className={styles.mj_position_container}>
      <ModelTitle title="招聘职位" type="jobs"></ModelTitle>
      <div
        className={styles.mj_position_jobs_container}
        style={{
          display: loading || isEmpty ? 'none' : 'flex',
        }}>
        {/*职位卡片*/}
        {category.map((item, index) => {
          return (
            <div
              style={{
                display: item.jobCount > 0 ? 'block' : 'none',
              }}
              key={index}
              className={styles.mj_position_jobs_card}
              onClick={() => {
                clickHandler(item?.categoryId);
              }}>
              <div className={styles.mj_position_jobs_en_title}>
                {splitStringAtFirstSpace(item.enName)}
              </div>
              <div className={styles.mj_position_jobs_zh_title}>
                {item.zhName}
              </div>
              <div className={styles.mj_position_jobs_btn}>
                <div>查看职位</div>
                <Icon
                  className={styles.mj_position_jobs_btn_icon}
                  fontClass="jiantou-41"
                />
              </div>
              <div className={styles.mj_position_jobs_count}>
                {item.jobCount > 999 ? '99+' : item.jobCount}
              </div>
            </div>
          );
        })}
      </div>
      <div
        className={styles.mj_position_allPisiton}
        style={{
          marginTop: loading || isEmpty ? 36 : 0,
        }}>
        <div
          className={styles.mj_position_allPisiton_text}
          onClick={(): void => {
            location.href =
              'https://ooia5293gn.jobs.feishu.cn/index/position/list';
          }}>
          查看全部在招岗位
        </div>
      </div>
    </div>
  );
};

export default Index;
